export default __webpack_public_path__ + "static/reckn-6c59e3b6a2de3d584935bb96276e8ecf.webp";